import router from '@/router'
import { useFormStore } from '@/stores/form'
import { useGlobalStore } from '@/stores/global'

export default function () {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()

  const showWorkType = formStore.calculateAgeFromDob() >= 15

  const {
    form: { values: formValues },
    extraMap
  } = formStore

  const res = {
    hideIdentity: true,
    serviceTransactionId: router.currentRoute.value.params.serviceId,
    mainServiceTransactionId: globalStore.startedService.serviceConfig.mainServiceTransactionId,
    isVirtualResidencyForInsideUaePerson: true || extraMap.isVirtualResidencyForInsideUaePerson,
    identificater: formValues.identificater,
    preferedLanguageId: formValues.preferredLanguageId,
    disableSelectIdentificater: false || extraMap.disableSelectIdentificater,
    isNewBorn: false || extraMap.isNewBorn,
    showUnifiedNumber: extraMap.showUnifiedNumber,
    showFileNumber: extraMap.showFileNumber,
    isVisaFileNumberRequired: globalStore.startedService?.isVisaFileNumberRequired,
    isResidencyFileNumberRequired:
      globalStore.startedService?.serviceConfig.isResidencyFileNumberRequired,
    changeStatus: globalStore.startedService.changeStatus,
    usingFileNumberOnly: globalStore.startedService.usingFileNumberOnly,
    showidentityNumberField: extraMap.showidentityNumberField,
    isNumberOfYearsDisabled: extraMap.isNumberOfYearsDisabled,
    applicantClassDetailId: formValues.applicantClassDetailId,
    hideSponsorInformation: globalStore.startedService.serviceConfig.hideSponsorInformation,
    showQualificationDescription: false,
    showProffessionNote: false,
    isEducationLevelCountryRequired: false,
    showWorkType,
    showCompanyName: false,
    hideOldEmiratesIdCardCopyOptions: true,
    showCurrentMobileNumber: true,
    showMobileNumbersListForTawzee: true,
    urgentServiceFlag: false,
    deliveryCompanyId: formValues.deliveryCompanyId,
    deliveryMethodId: formValues.deliveryMethodId,
    educationLevelId: formValues.educationLevelId,
    isPassportService: false,
    workTypeId: formValues.workTypeId
  }
  return res
}
